import { IJetcoLodgeClaimState, JetcoLodgeClaimModel } from './state';
import { createReducer, on, Action } from '@ngrx/store';
import {
  createFormGroupState,
  onNgrxForms, onNgrxFormsAction, setValue, SetValueAction, updateGroup, validate, wrapReducerWithFormStateUpdate
} from 'ngrx-forms';
import { GreenIdVerifiedAction, JetcoClaimAmountResponseAction, ResetFormAction, SubmitResponseAction } from './actions';
import { greaterThan, required, requiredTrue } from 'ngrx-forms/validation';
import { BankDetailsModel } from 'src/app/model/bank-details.model';


export const formName = 'cirtJetcoLodgeClaimForm';

export const jetcoLodgeClaimState: IJetcoLodgeClaimState = {
  form: createFormGroupState(formName, new JetcoLodgeClaimModel()),
  claimAmount: 0,
  lastModifiedTime: null
};

export const validateForm = updateGroup<JetcoLodgeClaimModel>({
  trainingCourse: validate(required),
  trainingProvider: validate(required),
  startDate: validate(required),
  invoiceAndReceipt: validate(required),
  completionCertificate: validate(required),
  endDate: validate(required),
  costOfTraining: validate(required, greaterThan(0)),
  declaration: validate(requiredTrue),
  bankDetails: updateGroup<BankDetailsModel>({
    accountName: validate(required),
    accountNumber: validate(required),
    bsb: validate(required),
  }),
  certifiedId: (state, parentState) => {
      const validateDoc = () => {
        const errors = {};

        if (!parentState.value.greenIdVerified && state.value.filename.length === 0){
          errors['customError'] = 'Certified ID is required if not provided verified digitally.'
        }

        return errors;
      }

      state = validate(state, validateDoc);
      return state;
  },
  greenIdVerified: (state, parentState) => {
    const validateGreenId = () => {
      const errors = {};

      if (parentState.value.certifiedId.filename.length === 0 && !state.value){
        errors['customError'] = 'You must verify digitally if you do not upload a certified ID.'
      }

      return errors;
    }

    state = validate(state, validateGreenId);
    return state;
  }
});

const reducer = createReducer(jetcoLodgeClaimState,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => {
    return state;
  }),
  on(ResetFormAction, (state) => {
    return {
      ...state,
      form: createFormGroupState(formName, new JetcoLodgeClaimModel()),
      lastModifiedTime: null
    };
  }),
  on(GreenIdVerifiedAction, (state, { verified }) => {
    return {
      ...state,
      form: setValue(Object.assign(new JetcoLodgeClaimModel(),
        {
          ...state.form.value,
          greenIdVerified: verified
        }
      ))(state.form)
    }
  }),
  on(SubmitResponseAction, (state, { payload }) => {
    return {
      ...state,
      lastModifiedTime: new Date(),
      form: createFormGroupState(formName, new JetcoLodgeClaimModel())
    };
  }),
  on(JetcoClaimAmountResponseAction, (state, { payload }) => {
    return {
      ...state,
      claimAmount: payload
    };
  }),
);


const reducerFormState = wrapReducerWithFormStateUpdate(
  reducer,
  s => s.form,
  validateForm,
);


export function jetcoLodgeClaimReducer(state: any | undefined, action: Action) {
  return reducerFormState(state, action);
}
